module.exports = {
    "contact_center_type": "intermedia",
    "settingsApi": {
        "baseUrl": "https://cahabamedicalcare.patient-assist.staging.agenta-cloud.com/",
        "url": "adpac/v3/getsettings",
        "fetchOnLogin": true,
        "_fetchOnLogin_comment": "true: defer getsettings until ?callid= is present (agent sessions/voice resolve runs in parallel and does not block settings). false: load settings at startup."
    },
    "authApi": {
        "enabled": true,
        "url": "adpac/v1/getauthtoken",
        "method": "POST",
        "tokenType": "Bearer"
    },
    "_ehrSource_comment": "ehr block: always used for Settings API ?ehr= query param. ehrSource \"settings\" (default): app runtime EHR from Settings API / settings.json. ehrSource \"tsconfig\": also force runtime EHR from this file — set one ehr flag true and the rest false.",
    "ehrSource": "settings",
    "ehr": {
        "epic": false,
        "cerner": false,
        "athena": true,
        "meditech": false,
        "nextgen": false,
        "ecw": false
    },
    "queryparameter": true,
    "simulator": false,
    "makeacall": {
        "_comment1": "This is to configure prefix (Code to Dial out from extension) to make a call feature which is present in source and subject cards",
        "prefix": "91"
    },
    "intermedia_callvariables": {
        "_comments": "intermedia callvariables which are added in VCC will generate a Biginterger value which needs to be configured in config file",
        "organizationId": "131960",
        "variables": {
            "caller_sourceid": {
                "name": "sourceid",
                "group": "Caller"
            },
            "patient_subjectid": {
                "name": "subjectid",
                "group": "Patient"
            }
        },
        "agentId_comment": "Use username or agentid for intermedia_agentId.",
        "_agentid_required_when_comment": "Used to resolve intermedia_userid via sessions/voice (parallel to getsettings). Recommended in ts-config for fetchOnLogin so agent id can resolve before Settings API returns callvariables.",
        "agentid_url_sessions": "https://pop6-apps.mycontactcenter.net/api/v3/cca/sessions",
        "agentid_url_session": "https://pop6-apps.mycontactcenter.net/api/v3/cca/sessions/",
        "token_intermedia": "nsFnmog0Z2G90b4sqkChLWBoWKIO43xyw2sEWIjL5B4=",
        "intermedia_agentId": "username"
    },
    "send_epic_client_id": false
}
;